// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2Rp_4","topBottomGutter":"Layout_topBottomGutter__3wZrI"};